import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { Buffer } from 'buffer'
import { FaImage, FaPlus, FaArrowLeft } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import CardService from "../../../services/card_services"

const targets = ["player", "business"]

class AdminCreateBud extends Component {
    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            success: false,
            fileData: null,
            fileSize: 0,
            fileExtension: null,
            thumbnailData: null,
            thumbnailSize: 0,
            thumbnailExtension: null,
            levels: [],
            collections: [],
            level: null,
            level_max: null,
            bud_name: null,
            description_en: null,
            description_fr: null,
            collection_uuid: null,
            target: null,
            discord: false,
            twitter: false,
        }
    }

    loadCollections = async () => {
        const collections = await CardService.getCollections()
        this.setState({ collections })
    }

    onFileHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['png'].includes(extension)) {
            NotificationManager.error('Invalid file')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('File exceeding 5Mo')
        } else {
            await this.setState({ fileSize: event.target.files[0].size, fileExtension: extension })
            reader.onloadend = () => this.processFile(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processFile = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ fileData: `data:image/${this.state.fileExtension};base64,${base64data}` })
    }

    onThumbnailHandler = async (event) => {
        const reader = new FileReader()
        const extension = event.target.files[0] && event.target.files[0].name.split('.').pop().toLowerCase()
        if (!extension || !['png'].includes(extension)) {
            NotificationManager.error('Invalid thumbnail')
        } else if (event.target.files[0].size > 5000000) {
            NotificationManager.error('Thumbnail exceeding 5Mo')
        } else {
            await this.setState({ thumbnailSize: event.target.files[0].size, thumbnailExtension: extension })
            reader.onloadend = () => this.processThumbnail(reader)
            reader.readAsArrayBuffer(event.target.files[0])
        }
    }

    processThumbnail = async (reader) => {
        const buffer = Buffer.from(reader.result)
        const base64data = buffer.toString('base64')
        this.setState({ thumbnailData: `data:image/${this.state.thumbnailExtension};base64,${base64data}` })
    }

    componentDidMount = async () => {
        this.loadCollections()
        const levels = await CardService.getLevels()
        this.setState({ levels })
    }

    setCollection = async (e) => {
        this.setState({ collection_uuid: e.target.value })
        const nb = await CardService.getCollectionNumber(e.target.value)
        for (let collection of this.state.collections) {
            if (collection.collection_uuid === e.target.value)
                this.setState({ bud_name: ` ${collection.collection_name.at(-1) === 's'? collection.collection_name.slice(0, -1) : collection.collection_name} #${nb}` })
        }
    }

    create = async () => {
        if (!this.state.fileData || !this.state.thumbnailData || !this.state.level || !this.state.bud_name || !this.state.description_fr || !this.state.description_en || !this.state.collection_uuid || !this.state.target)
            NotificationManager.error('Missing information')
        else {
            try {
                this.setState({ processing: true })
                const data = await CardService.createBud(this.state.level, this.state.level_max, this.state.fileData, this.state.thumbnailData, this.state.bud_name, 
                    {en: this.state.description_en, fr: this.state.description_fr}, this.state.collection_uuid, this.state.target, this.state.discord, this.state.twitter)
                NotificationManager.success(data.message)
                this.setState({ processing: false, success: true })
            } catch (e) {
                this.setState({ processing: false })
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Create New Bud"
                    breadcrumbs={[
                        { label: 'Buds', href: '/admin/buds' },
                        { label: 'Create' }
                    ]}
                >
                    <div className="max-w-4xl mx-auto space-y-6">
                        {/* Instructions */}
                        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                            <p className="text-blue-800 font-medium">Set all required information to create a new Bud</p>
                        </div>

                        {/* Image Uploads Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 space-y-6">
                            <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                                <FaImage className="text-blue-500" />
                                Visual Assets
                            </h3>

                            {/* HQ Visual */}
                            <div className="space-y-3">
                                <label className="block text-sm font-semibold text-gray-700">HQ Bud Visual</label>
                                {this.state.fileData && (
                                    <div className="flex justify-center">
                                        <img 
                                            src={this.state.fileData} 
                                            alt="Bud visual" 
                                            className="max-w-xs rounded-lg shadow-md border-2 border-gray-300"
                                        />
                                    </div>
                                )}
                                <input 
                                    type="file" 
                                    onChange={(e) => this.onFileHandler(e)}
                                    className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 cursor-pointer"
                                />
                                <p className="text-xs text-gray-500">*PNG format only, max 5MB</p>
                            </div>

                            {/* Thumbnail */}
                            <div className="space-y-3 pt-4 border-t border-gray-200">
                                <label className="block text-sm font-semibold text-gray-700">Thumbnail</label>
                                {this.state.thumbnailData && (
                                    <div className="flex justify-center">
                                        <img 
                                            src={this.state.thumbnailData} 
                                            alt="Bud thumbnail" 
                                            className="max-w-xs rounded-lg shadow-md border-2 border-gray-300"
                                        />
                                    </div>
                                )}
                                <input 
                                    type="file" 
                                    onChange={(e) => this.onThumbnailHandler(e)}
                                    className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 cursor-pointer"
                                />
                                <p className="text-xs text-gray-500">*PNG format only, max 5MB</p>
                            </div>
                        </div>

                        {/* Bud Details Form */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 space-y-4">
                            <h3 className="text-lg font-bold text-gray-900">Bud Details</h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {/* Starting Level */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Starting Level *</label>
                                    <select 
                                        onChange={(e) => this.setState({ level: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        defaultValue=""
                                    >
                                        <option value="" disabled>Select a starting level</option>
                                        {this.state.levels.map(lvl =>
                                            <option key={lvl} value={lvl}>{lvl}</option>
                                        )}
                                    </select>
                                </div>

                                {/* Max Level */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Max Level (Optional)</label>
                                    <select 
                                        onChange={(e) => this.setState({ level_max: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        defaultValue=""
                                    >
                                        <option value="">No cap level</option>
                                        {this.state.levels.map(lvl =>
                                            <option key={lvl} value={lvl}>{lvl}</option>
                                        )}
                                    </select>
                                </div>

                                {/* Collection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Collection *</label>
                                    <select 
                                        onChange={this.setCollection}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        defaultValue=""
                                    >
                                        <option value="" disabled>Select a collection</option>
                                        {this.state.collections.map(collection =>
                                            <option key={collection.collection_uuid} value={collection.collection_uuid}>
                                                {collection.collection_name}
                                            </option>
                                        )}
                                    </select>
                                </div>

                                {/* Target */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Target *</label>
                                    <select 
                                        onChange={(e) => this.setState({ target: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        defaultValue=""
                                    >
                                        <option value="" disabled>Select a target</option>
                                        {targets.map(target =>
                                            <option key={target} value={target}>{target}</option>
                                        )}
                                    </select>
                                </div>
                            </div>

                            {/* Bud Name */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Bud Name *</label>
                                <input 
                                    type="text" 
                                    placeholder="Set Bud name" 
                                    value={this.state.bud_name || ''} 
                                    onChange={(e) => this.setState({ bud_name: e.target.value })}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                />
                            </div>

                            {/* Descriptions */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Description (English) *</label>
                                <textarea 
                                    placeholder="Description EN" 
                                    onChange={(e) => this.setState({ description_en: e.target.value })}
                                    rows="4"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none resize-none"
                                ></textarea>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Description (French) *</label>
                                <textarea 
                                    placeholder="Description FR" 
                                    onChange={(e) => this.setState({ description_fr: e.target.value })}
                                    rows="4"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none resize-none"
                                ></textarea>
                            </div>
                        </div>

                        {/* Social Media Notifications */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 space-y-4">
                            <h3 className="text-lg font-bold text-gray-900">Social Media Push Notifications</h3>

                            {/* Discord */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Discord Push?</label>
                                <div className="flex gap-4">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input 
                                            type="radio" 
                                            name="discord" 
                                            checked={this.state.discord}
                                            onChange={() => this.setState({discord: true})}
                                            className="w-4 h-4 text-blue-600 focus:ring-2 focus:ring-blue-500"
                                        />
                                        <span className="text-sm text-gray-700">Yes</span>
                                    </label>
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input 
                                            type="radio" 
                                            name="discord" 
                                            checked={!this.state.discord}
                                            onChange={() => this.setState({discord: false})}
                                            className="w-4 h-4 text-blue-600 focus:ring-2 focus:ring-blue-500"
                                        />
                                        <span className="text-sm text-gray-700">No</span>
                                    </label>
                                </div>
                            </div>

                            {/* Twitter */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Twitter Push?</label>
                                <div className="flex gap-4">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input 
                                            type="radio" 
                                            name="twitter" 
                                            checked={this.state.twitter}
                                            onChange={() => this.setState({twitter: true})}
                                            className="w-4 h-4 text-blue-600 focus:ring-2 focus:ring-blue-500"
                                        />
                                        <span className="text-sm text-gray-700">Yes</span>
                                    </label>
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input 
                                            type="radio" 
                                            name="twitter" 
                                            checked={!this.state.twitter}
                                            onChange={() => this.setState({twitter: false})}
                                            className="w-4 h-4 text-blue-600 focus:ring-2 focus:ring-blue-500"
                                        />
                                        <span className="text-sm text-gray-700">No</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-end gap-3">
                            {this.state.processing ? (
                                <div className="px-6 py-3 bg-gray-100 text-gray-500 rounded-lg font-medium">
                                    Processing... Please wait
                                </div>
                            ) : this.state.success ? (
                                <button 
                                    onClick={() => window.location.href = "/admin/buds"}
                                    className="px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white rounded-lg hover:from-gray-600 hover:to-gray-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    <FaArrowLeft />
                                    Back to Buds
                                </button>
                            ) : (
                                <button 
                                    onClick={this.create}
                                    className="px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    <FaPlus />
                                    Create New Bud
                                </button>
                            )}
                        </div>
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminCreateBud)